import type { PropType } from 'virtual-vue';

/**
 * KeyboardInput组件的props
 */
export const KeyboardInputProps = {
  /**
   * 输入值
   * @default ''
   */
  value: {
    type: String,
    default: '',
  },
  /**
   * 输入框最大输入长度
   * @default 9
   */
  maxlength: {
    type: Number,
    default: 9,
  },
  /**
   * 输入提示文案
   * @default ''
   */
  placeholder: {
    type: String,
    default: '',
  },
  /**
   * 输入提示语展示位置，可选值为 'left'（在光标左侧）或 'right'（在光标右侧）
   * @default 'right'
   */
  placeholderPosition: {
    type: String as PropType<'left' | 'right'>,
    default: 'right',
  },
  /**
   * 是否可输入小数点
   * @default true
   */
  decimal: {
    type: Boolean,
    default: true,
  },
  /**
   * 键盘类型，可选值为 'default'（默认键盘）、'confirm'（带确认按钮的键盘）
   * @default 'default'
   */
  type: {
    type: String as PropType<'default' | 'confirm'>,
    default: 'default',
  },
  /**
   * 键盘内的确认按钮文案
   * @default 'OK'
   */
  confirmBtnText: {
    type: String,
    default: 'OK',
  },
  /**
   * 是否允许用户点击键盘内嵌的确认按钮进行提交
   * @default false
   */
  confirmBtnEnable: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否一直显示键盘
   * @default false
   */
  alwaysShowKeyboard: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否禁用
   * @default false
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * 输入前处理，一般用于校验输入字符，返回true才让输入
   * @default () => true
   */
  beforeInput: {
    type: Function as PropType<
      (
        /** 输入后的完整字符串 */
        newVal: string,
        /** 输入前的完整字符串 */
        oldVal: string,
        /** 当前输入的字符 */
        char: string
      ) => boolean
    >,
    default: (newVal: string, oldVal: string, char: string) => true,
  },
};
